module.exports = __webpack_public_path__ + "img/coverage-5.8b3104a3.svg";